import { render, staticRenderFns } from "./DialogRoseLega.vue?vue&type=template&id=7b9b88fe&scoped=true&"
import script from "./DialogRoseLega.vue?vue&type=script&lang=js&"
export * from "./DialogRoseLega.vue?vue&type=script&lang=js&"
import style0 from "./DialogRoseLega.vue?vue&type=style&index=0&id=7b9b88fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9b88fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b9b88fe')) {
      api.createRecord('7b9b88fe', component.options)
    } else {
      api.reload('7b9b88fe', component.options)
    }
    module.hot.accept("./DialogRoseLega.vue?vue&type=template&id=7b9b88fe&scoped=true&", function () {
      api.rerender('7b9b88fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogRoseLega.vue"
export default component.exports